module.exports = __webpack_public_path__ + "img/logo.083f3cf2.svg";